var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { queryDisbursements } from "./query.js";
import { createTransfersEventsSource } from "./web/sse.js";
export { ImaraClient as ImaraClient } from "./client.js";
export * from "./query.js";
export * from "./web/sse.js";
export function getOrganizationWallet(imc, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = new Headers();
        headers.set("Accept", "application/json");
        const res = yield imc.fetch(imc.joinPath("/v1/company", companyId, "/account/wallet"), {
            method: "GET",
            headers,
        });
        return (yield res.json());
    });
}
export function getSupportedBanks(imc) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = new Headers();
        headers.set("Accept", "application/json");
        const res = yield imc.fetch(imc.joinPath("/v1/query/banks"), {
            method: "GET",
            headers,
        });
        return (yield res.json());
    });
}
export function previewDisbursement(imc, input) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        if (input.processorKey) {
            headers.set("Imara-Processor-Key", input.processorKey.toString());
        }
        if (input.processor) {
            headers.set("Imara-Processor", input.processor);
        }
        const res = yield imc.fetch(imc.joinPath("/v1/disburse/preview"), {
            method: "POST",
            body: JSON.stringify(input.data),
            headers: headers,
        });
        const processorname = res.headers.get("Imara-Processor");
        const processorkey = res.headers.get("Imara-Processor-Key");
        const output = {
            result: yield res.json(),
        };
        if (processorname) {
            if (!("processor" in output)) {
                output["processor"] = {};
            }
            output["processor"]["name"] = processorname;
        }
        if (processorkey) {
            if (!("processor" in output)) {
                output["processor"] = {};
            }
            output["processor"]["key"] = processorkey;
        }
        return output;
    });
}
export function makeDisbursement(imc, input) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        if (input.idempotentKey) {
            headers.set("Idempotent-Key", input.idempotentKey);
        }
        if (input.processorKey) {
            headers.set("Imara-Processor-Key", input.processorKey.toString());
        }
        if (input.processor) {
            headers.set("Imara-Processor", input.processor);
        }
        if (input.callbackUrl) {
            headers.set("Imara-Callback-Url", input.callbackUrl);
        }
        if (input.limitAccount) {
            headers.set("Imara-Limit-Account", input.limitAccount);
        }
        if (input.holdingAccount) {
            headers.set("Imara-Holding-Account", input.holdingAccount);
        }
        if ("debitAccount" in input) {
            headers.set("Imara-Debit-Account", input.debitAccount);
        }
        if ("companyId" in input) {
            headers.set("Imara-Company-Id", input.companyId);
        }
        const res = yield imc.fetch(imc.joinPath("/v1/disburse"), {
            method: "POST",
            body: JSON.stringify(input.payload),
            headers: headers,
        });
        return (yield res.json());
    });
}
export function getOverdraftLimit(imc, companyId, input) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield imc.fetch(imc.joinPath("/v1/company", companyId, "/overdraft-limit") +
            "?currency=" +
            input.currency, {
            method: "GET",
        });
        return (yield res.json());
    });
}
export function setOverdraftLimit(imc, companyId, input) {
    return __awaiter(this, void 0, void 0, function* () {
        yield imc.fetch(imc.joinPath("/v1/company", companyId, "/overdraft-limit"), {
            method: "PUT",
            body: JSON.stringify({ amount: input.amount, currency: input.currency }),
            headers: {
                "Content-Type": "application/json",
            },
        });
    });
}
const Imara = {
    getOrganizationWallet,
    listSupportedBanks: getSupportedBanks,
    previewDisbursement,
    makeDisbursement,
    getOverdraftLimit,
    setOverdraftLimit,
    queryDisbursements,
    createTransfersEventsSource,
};
export default Imara;
